import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'

/**
 * Displays a transparent loading spinner when open that overlays the whole page.
 *
 * Should only be used during a process that requires the prevention of all user
 * interaction during until the process is finished.
 */
const TransparentPreloader = () => {
    const { preloaderStore } = useContext(StoresContext)

    return preloaderStore.transparentPreloaderIsOpen ? (
        <div className="transparent-preloader">
            <div className="icon-block">
                <img className="circle" src={ICONS.preloader_circle} alt="preloader" />
            </div>
        </div>
    ) : null
}

export default observer(TransparentPreloader)
